export default __webpack_public_path__ + "static/mountains-dac0a198ee5442ef170b62f8d6a8287d.png";